module.exports = __webpack_public_path__ + "fonts/ARIClean-Bold.b1ae92ce.otf";